import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const QueryPendingRetouchTransfers = (params?: Record<string, unknown>) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.PendingRetouchTransfersQueryURL.QueryPendingRetouchTransfers,
        method: RequestType.GET,
        params,
    });

export const PendingRetouchTransfersQuery = {
    QueryPendingRetouchTransfers,
};
